<div style="height: 100px;"></div>
<div *ngIf="movie_details && movie_video" class="row mx-0 p-2 w-100 justify-content-center">
    <div class="col-11 col-md-6 mb-4 embed-responsive embed-responsive-16by9">
        <iframe class="embed-responsive-item" [src]="movie_video_url" allowfullscreen></iframe>
    </div>
    <div  class="col-11 col-md-3 p-0 pl-md-4 text-white mutiinfo">
        <h1>{{movie_details.title}}</h1>
        <p><em>{{movie_details.tagline}}</em></p>
        <p>{{movie_details.year}} | &#x2605; {{movie_details.vote_average}} | {{movie_details.runtime}} mins</p>
        <p> <strong>Genres</strong> : {{movie_details.genres_str}} <br>
            <strong>Spoken Languages</strong> : {{movie_details.lang_str}}
        </p>
        <button class="btn btn-primary" *ngIf="!inWatchList" (click)="add_watchlist()">Add to Watchlist</button>
        <div *ngIf="addMessage" >
            <ngb-alert #addAlert type="success" (closed)="addMessage = ''">
                {{ addMessage }}
            </ngb-alert>
        </div>
        
        <button class="btn btn-primary" *ngIf="inWatchList" (click)="remove_watchlist()">Remove from Watchlist</button>
        <div *ngIf="removeMessage" >
            <ngb-alert #removeAlert type="danger" (closed)="removeMessage = ''">
                {{ removeMessage }}
            </ngb-alert>
        </div>
    </div>
    <div class="col-11 col-md-9 p-0 text-white moreinfo">
        <h4><strong>Description</strong></h4>
        <p>{{movie_details.overview}}</p>
        <h4 class="mt-4"><strong>Share</strong></h4>
        <p>
            <a class="mr-3" *ngIf="twitterURL" [href]="twitterURL" target="_blank"><img [src]="twitter_icon" style="width: 32px;"></a>
            <a class="mr-3" *ngIf="facebookURL" [href]="facebookURL" target="_blank"><img [src]="facebook_icon" style="width: 32px;"></a>
        </p>
        <h2 class="mt-4">Full Cast and Crew</h2>
        <div class="scrolling-wrapper">
            <div class="scrolling-card" *ngFor="let cast of casts"  (click)="openModal(cast.id,cast.profile_path)">
                <img [src]="cast.profile_path" class="img-fluid">
                <p><strong>{{cast.name}}<br>AS<br></strong>{{cast.character}}</p>
            </div>
        </div>
        <h2 class="mt-4">Reviews <span style="color: rgba(255,255,255,0.5);">{{reviews.length}}</span></h2>
        <div class="review-card row mx-0" *ngFor="let review of reviews">
            <div class="img-wrapper col"><img class="img-fluid" [src]="review.avatar_path"></div>
            <div *ngIf="isMobile" class="w-100"></div>
            <div class="col p-3">
                <h4>
                    <strong>A review created by {{review.author}} </strong>
                    <br *ngIf="isMobile" >
                    <span style="display: inline-block;height: 28px;width: 60px;border-radius: 14px;background-color: black;color: white;text-align: center;">
                        &#x2605; {{review.rating}}
                    </span>
                </h4>
                <p class="my-3" style="color: rgba(0,0,0,0.5);">Written by {{review.author}} on {{review.created_at | date:'medium'}}</p>
                <div class="review-content mb-3">{{review.content}}</div>
                <a [href]="review.url" target="_blank">Read the rest </a>
            </div>
        </div>
        <app-carousel-many [dataReceived] = "recommendedMovies" [dataReceived_arr] = "recommendedMovies_arr" [cata]="'Recommended TV Shows'" [isMobile] = "isMobile" ></app-carousel-many>
        <app-carousel-many [dataReceived] = "similarMovies" [dataReceived_arr] = "similarMovies_arr" [cata]="'Similar TV Shows'" [isMobile] = "isMobile" ></app-carousel-many>
    </div>
    
</div>
    
<div style="height: 100px;"></div>